<template>
  <div >{{ remark }}</div>
</template>
<script>
import wsMixin from "@/modules/customerVbzWorksheet/wsMixin";

export default {
  name: 'Remark',
  mixins: [wsMixin],
  props: {
    column:Object,
    absence:Object,
    isAssignedToDifferentView:Boolean,
    isDisabled:{type:Boolean,default:false}
  },

  computed: {
    remark() {
      return this.mx_remark(this.absence);
    },
  },
};
</script>